import { gql } from 'apollo-boost';
import { MESSAGE_REPLY_PREVIEW_FRAGMENT } from '../../fragments/message/message-reply-preview';

export const GET_MESSAGE_REPLY_PREVIEW = gql`
    query($data: GetMessageInput!) {
        getMessage(data: $data, trackView: false) {
            ...MessageReplyPreview
        }
    }
    ${MESSAGE_REPLY_PREVIEW_FRAGMENT}
`;
